import { type ReactNode } from 'react'
import { type AuditProps } from '@terros/common'
import { Stack } from '@mantine/core'
import { TDrawer } from '../terros'
import { useSortedModifications } from './useSortedModifications'
import { ModificationEntry } from './ModificationEntry'

type Props = AuditProps & {
  opened: boolean
  close: () => void
  modifyOnly?: boolean
}

export const AuditDrawer = ({ opened, close, modifyOnly = false, ...props }: Props): ReactNode => {
  return (
    <TDrawer opened={opened} size='md' title='Modification History' onClose={close}>
      <ModificationStack {...props} modifyOnly={modifyOnly} />
    </TDrawer>
  )
}

export const ModificationStack = ({
  modifiedBy,
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
  modifyOnly = false,
}: AuditProps & { modifyOnly?: boolean }): ReactNode => {
  const sortedModifications = useSortedModifications({
    modifiedBy,
    createdAt,
    createdBy,
    updatedAt,
    updatedBy,
  })
  return (
    <Stack gap='sm'>
      {sortedModifications.map((modification, index) => {
        const isCreated = index === sortedModifications.length - 1 && !modifyOnly
        return (
          <ModificationEntry
            isCreated={isCreated}
            key={`${modification.userId}-${modification.timestamp}-${index}`}
            modification={modification}
          />
        )
      })}
    </Stack>
  )
}
